import { useCallback } from "react";

import useTypedContext from "hooks/useTypedContext";
import { Space } from "types/generated";
import { hasAdminAccess } from "utils/access";
import { AccountContext } from "views/AccountWrapper";

type AiIntegration = {
  space: Pick<Space, "id" | "accessLevel">;
};

const useCanManageAiIntegration = (): ((integration: AiIntegration) => boolean) => {
  const { viewer } = useTypedContext(AccountContext);

  return useCallback(
    (integration: AiIntegration) => {
      if (viewer.admin) {
        return true;
      }

      return hasAdminAccess(viewer, integration.space.id);
    },
    [viewer]
  );
};

export default useCanManageAiIntegration;
